import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";

const cookies = new Cookies();

const S = {
  page: { padding: 24, direction: "rtl", background: "#f8fafc", minHeight: "100vh", fontFamily: "'Segoe UI', Tahoma, sans-serif" },
  inner: { paddingInline: "max(24px, calc((100% - 1180px) / 2))", boxSizing: "border-box" },
  h1: { fontSize: 24, fontWeight: 800, color: "#0f172a", margin: "0 0 6px" },
  sub: { fontSize: 13, color: "#64748b", margin: "0 0 18px" },
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 1px 3px rgba(0,0,0,.08)", border: "1px solid #eef2f7", marginBottom: 16 },
  pad: { padding: 20 },
  input: { padding: "12px 14px", borderRadius: 10, border: "1px solid #e2e8f0", fontSize: 15, outline: "none", fontFamily: "inherit" },
  scanInput: { padding: "15px 18px", borderRadius: 12, border: "2px solid #2563eb", fontSize: 21, fontWeight: 800, textAlign: "center", outline: "none", background: "#eff6ff", fontFamily: "inherit", width: "100%" },
  btnPrimary: { padding: "12px 22px", borderRadius: 10, border: "none", background: "#2563eb", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 15 },
  btnOk: { padding: "11px 20px", borderRadius: 10, border: "none", background: "#16a34a", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 14 },
  btnPrint: { padding: "8px 16px", borderRadius: 9, border: "1px solid #c7d2fe", background: "#eef2ff", color: "#4338ca", fontWeight: 700, cursor: "pointer", fontSize: 13 },
  btnGhost: { padding: "9px 16px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#334155", fontWeight: 600, cursor: "pointer", fontSize: 13 },
  btnDanger: { padding: "6px 13px", borderRadius: 8, border: "1px solid #fecaca", background: "#fff", color: "#dc2626", fontWeight: 700, cursor: "pointer", fontSize: 12.5 },
  btnDis: { opacity: .45, cursor: "not-allowed" },
  th: { textAlign: "right", padding: "11px 12px", fontSize: 12, color: "#64748b", fontWeight: 700, borderBottom: "2px solid #f1f5f9", whiteSpace: "nowrap" },
  td: { textAlign: "right", padding: "12px", fontSize: 13.5, color: "#0f172a", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" },
  stat: { flex: 1, minWidth: 140, padding: "16px 18px", background: "#fff", borderRadius: 14, border: "1px solid #eef2f7" },
  statLabel: { fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 5 },
  statValue: { fontSize: 24, fontWeight: 800, color: "#0f172a" },
  chip: { display: "inline-block", padding: "2px 8px", borderRadius: 12, fontSize: 11, fontWeight: 600, background: "#eff6ff", color: "#2563eb", border: "1px solid #dbeafe", marginInlineEnd: 4, marginBottom: 3 },
  empty: { padding: 50, textAlign: "center", color: "#94a3b8", fontSize: 15 },
  badge: (bg, color) => ({ display: "inline-block", padding: "3px 11px", borderRadius: 20, fontSize: 12, fontWeight: 700, background: bg, color }),
  tabs: { display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" },
  tab: (on) => ({
    padding: "12px 22px", borderRadius: 11, cursor: "pointer", fontSize: 14.5, fontWeight: 700,
    border: on ? "1px solid #2563eb" : "1px solid #e2e8f0",
    background: on ? "#2563eb" : "#fff", color: on ? "#fff" : "#334155",
    display: "flex", alignItems: "center", gap: 8,
  }),
  tabCount: (on) => ({
    padding: "1px 8px", borderRadius: 10, fontSize: 12, fontWeight: 800,
    background: on ? "rgba(255,255,255,.25)" : "#f1f5f9", color: on ? "#fff" : "#64748b",
  }),
  warnBox: { padding: "13px 16px", borderRadius: 11, background: "#fffbeb", border: "1px solid #fde68a", color: "#92400e", fontSize: 13.5, marginBottom: 14, fontWeight: 600 },
  okBox: { padding: "13px 16px", borderRadius: 11, background: "#f0fdf4", border: "1px solid #bbf7d0", color: "#166534", fontSize: 13.5, marginBottom: 14, fontWeight: 600 },
  overlay: { position: "fixed", inset: 0, background: "rgba(15,23,42,.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: 16 },
  modal: { background: "#fff", borderRadius: 18, width: "100%", maxWidth: 620, maxHeight: "92vh", overflowY: "auto", direction: "rtl", boxShadow: "0 20px 50px rgba(0,0,0,.3)" },
  modalHead: { padding: "18px 22px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" },
  faultBtn: (on) => ({
    padding: "11px 8px", borderRadius: 10, cursor: "pointer", fontSize: 13, fontWeight: 700,
    border: on ? "2px solid #dc2626" : "1px solid #e2e8f0",
    background: on ? "#fef2f2" : "#fff", color: on ? "#b91c1c" : "#475569",
    textAlign: "center",
  }),
  secBtn: (on, color) => ({
    flex: 1, padding: "14px 10px", borderRadius: 12, cursor: "pointer", fontSize: 15, fontWeight: 800,
    border: on ? `2px solid ${color}` : "1px solid #e2e8f0",
    background: on ? "#fff" : "#f8fafc", color: on ? color : "#64748b",
  }),
  rowSana: { background: "#fffbf5" },
  rowSoft: { background: "#faf9ff" },
};

const FAULTS = [
  { k: 'fault_screen', l: 'شاشة' },
  { k: 'fault_class', l: 'كلاس' },
  { k: 'fault_battery', l: 'بطارية' },
  { k: 'fault_cam_front', l: 'كاميرا أمامية' },
  { k: 'fault_cam_back', l: 'كاميرا خلفية' },
  { k: 'fault_board', l: 'بورد' },
  { k: 'fault_fingerprint', l: 'بصمة' },
  { k: 'fault_other', l: 'أخرى' },
];

const emptyFaults = () => ({
  fault_screen: false, fault_class: false, fault_battery: false,
  fault_cam_front: false, fault_cam_back: false, fault_board: false,
  fault_fingerprint: false, fault_other: false, no_touch_id: false,
});

// الكشف يُبنى بسلسلة HTML، فأي اسم فيه < أو & يفسد الورقة
const esc = (v) => String(v == null ? '' : v)
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

export default class ExchangeReturns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // نوع القائمة: exchange = رواجع استبدالات · stock = تحويل من المخزن
      // قائمة مفتوحة واحدة لكل نوع، فالتبديل يحمّل قائمة أخرى.
      kind: 'exchange',
      tab: 'open',           // open | history
      open: null,            // القائمة المفتوحة
      lists: [],             // كل القوائم (للسرد والعدّادات)
      archive: null,         // قائمة مقفولة معروضة للقراءة
      loadingOpen: true,
      loadingArchive: false,
      listsError: null,
      busy: false,

      modal: null,
      section: null,
      faults: emptyFaults(),
      notes: '',
      confirmClose: false,
    };
    this.scanRef = React.createRef();
  }

  header() { return { "Content-Type": "application/json", token: cookies.get("token") }; }
  unwrap(r) { return r.data && r.data.data ? r.data.data : r.data; }
  errMsg(e) {
    const r = e && e.response && e.response.data;
    if (!r) return 'تعذّر الاتصال بالخادم';
    return r.message || r.msg || 'حدث خطأ';
  }

  componentDidMount() { this.loadOpen(); this.loadLists(); }

  loadOpen = () => {
    this.setState({ loadingOpen: true });
    axios.get(host + 'exchange/list?kind=' + this.state.kind, { headers: this.header() })
      .then(r => this.setState({ open: this.unwrap(r), loadingOpen: false }, () => this.focusScan()))
      .catch(e => {
        this.setState({ loadingOpen: false });
        toast.error(this.errMsg(e), { position: "bottom-center", autoClose: 4000 });
      });
  };

  loadLists = () => {
    axios.get(host + 'exchange/lists', { headers: this.header() })
      .then(r => {
        const d = this.unwrap(r);
        this.setState({ lists: (d && d.lists) || [], listsError: null });
      })
      // كان `.catch(() => {})` — فأي خطأ من الخادم (عمود ناقص مثلاً)
      // يترك القوائم فارغة بلا أي إشارة، فتبدو «لا قوائم» والسبب مخفي.
      .catch(e => {
        const msg = this.errMsg(e);
        this.setState({ lists: [], listsError: msg });
        toast.error('تعذّر تحميل القوائم — ' + msg,
          { position: "bottom-center", autoClose: 7000 });
      });
  };

  fetchList = (id) => axios
    .get(host + 'exchange/list?id=' + id, { headers: this.header() })
    .then(r => this.unwrap(r));

  openArchive = (id) => {
    this.setState({ loadingArchive: true, archive: null });
    this.fetchList(id)
      .then(d => this.setState({ archive: d, loadingArchive: false }))
      .catch(e => {
        this.setState({ loadingArchive: false });
        toast.error(this.errMsg(e), { position: "bottom-center", autoClose: 4000 });
      });
  };

  focusScan() {
    if (this.state.tab !== 'open') return;
    const el = this.scanRef.current;
    if (el) { el.value = ''; el.focus(); }
  }

  // ===== المسح =====
  onScan = (raw) => {
    const code = String(raw || '').trim();
    if (!code) return;
    this.setState({ busy: true });
    axios.post(host + 'exchange/scan',
      { code, kind: this.state.kind, token: cookies.get("token") },
      { headers: this.header() })
      .then(r => {
        const d = this.unwrap(r);
        this.setState({
          busy: false, modal: d, section: null, notes: '',
          faults: { ...emptyFaults(), no_touch_id: !!(d.device && d.device.no_touch_id) },
        });
      })
      .catch(e => {
        this.setState({ busy: false });
        toast.error(this.errMsg(e), { position: "bottom-center", autoClose: 5000 });
        this.focusScan();
      });
  };

  toggleFault = (k) => this.setState(p => ({ faults: { ...p.faults, [k]: !p.faults[k] } }));
  anyFault() { const f = this.state.faults; return FAULTS.some(x => f[x.k]); }
  // العطل إلزامي للصيانة فقط. السوفت مشكلته برمجية (قفل iCloud/شبكة/
  // حساب) فلا عطل مادي يُحدَّد، والاسم "مقفول سليم" تصنيف صحيح قائم.
  faultRequired() { return this.state.section === 'sana'; }
  canAdd() {
    if (!this.state.section) return false;
    if (this.faultRequired() && !this.anyFault()) return false;
    return this.state.notes.trim().length > 0;
  }

  confirmAdd = () => {
    if (!this.canAdd()) return;
    const { modal, section, faults, notes } = this.state;
    this.setState({ busy: true });
    axios.post(host + 'exchange/add', {
      device_id: modal.device.device_id, section, ...faults,
      kind: this.state.kind,
      notes: notes.trim(), token: cookies.get("token"),
    }, { headers: this.header() })
      .then(r => {
        const d = this.unwrap(r);
        toast.success(`أُضيف #${modal.device.device_id} — ${d.preview_name || ''}`,
          { position: "bottom-center", autoClose: 3000 });
        this.setState({ busy: false, modal: null }, () => { this.loadOpen(); this.loadLists(); });
      })
      .catch(e => {
        this.setState({ busy: false });
        toast.error(this.errMsg(e), { position: "bottom-center", autoClose: 5000 });
      });
  };

  removeItem = (item) => {
    this.setState({ busy: true });
    axios.post(host + 'exchange/remove', { item_id: item.item_id, token: cookies.get("token") },
      { headers: this.header() })
      .then(() => {
        toast.success(`حُذف #${item.device_id} — الجهاز لم يتغيّر`,
          { position: "bottom-center", autoClose: 2500 });
        this.setState({ busy: false }, () => { this.loadOpen(); this.loadLists(); });
      })
      .catch(e => {
        this.setState({ busy: false });
        toast.error(this.errMsg(e), { position: "bottom-center", autoClose: 4000 });
      });
  };

  doClose = () => {
    const { open } = this.state;
    this.setState({ busy: true });
    axios.post(host + 'exchange/close', { list_id: open.list.id, token: cookies.get("token") },
      { headers: this.header() })
      .then(r => {
        const d = this.unwrap(r);
        toast.success(d.msg || 'قُفلت القائمة', { position: "bottom-center", autoClose: 5000 });
        (d.skipped || []).forEach(s => toast.warn(`#${s.device_id} — ${s.reason}`,
          { position: "bottom-center", autoClose: 7000 }));
        this.setState({ busy: false, confirmClose: false },
          () => { this.loadOpen(); this.loadLists(); });
      })
      .catch(e => {
        this.setState({ busy: false, confirmClose: false });
        toast.error(this.errMsg(e), { position: "bottom-center", autoClose: 5000 });
      });
  };

  // ============================================================
  //  طباعة الكشف
  //
  //  نافذة مستقلة لا `@media print` على الصفحة: أنماط الصفحة سطرية
  //  (inline) وقواعد الطباعة لا تصل إليها. والنافذة المستقلة تعطي
  //  ورقة نظيفة بلا قائمة جانبية ولا أزرار.
  // ============================================================
  printSheet = (data) => {
    if (!data || !data.list) return;
    const L = data.list;
    const items = data.items || [];

    const rows = items.map((it, i) => `
      <tr>
        <td class="c">${i + 1}</td>
        <td class="c b">${esc(it.device_id)}</td>
        <td>${esc(it.sn)}</td>
        <td>${esc(it.prev_composite)}</td>
        <td class="c">${it.section === 'sana' ? 'صيانة' : 'سوفت'}</td>
        <td>${esc((it.fault_labels || []).join(' · '))}</td>
        <td class="b">${esc(it.current_composite || it.preview_name)}</td>
        <td>${esc(it.notes)}</td>
        <td class="c">${it.prev_order_id ? esc(it.prev_order_id) : '—'}</td>
      </tr>`).join('');

    const html = '<!DOCTYPE html>' +
      '<html dir="rtl" lang="ar"><head><meta charset="utf-8">' +
      '<title>كشف رواجع استبدالات #' + esc(L.id) + '</title>' +
      '<style>' +
      '@page { size: A4 landscape; margin: 12mm 10mm; }' +
      '* { box-sizing: border-box; }' +
      "body { font-family: 'Segoe UI', Tahoma, Arial, sans-serif; direction: rtl; margin: 0; color: #111; font-size: 11.5px; }" +
      '.head { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #111; padding-bottom: 8px; margin-bottom: 12px; }' +
      '.brand { font-size: 20px; font-weight: 800; letter-spacing: .5px; }' +
      '.title { font-size: 14px; font-weight: 700; margin-top: 3px; }' +
      '.meta { text-align: left; font-size: 11px; line-height: 1.7; }' +
      '.meta b { display: inline-block; min-width: 62px; }' +
      '.sum { display: flex; gap: 10px; margin-bottom: 12px; }' +
      '.box { border: 1px solid #999; border-radius: 5px; padding: 7px 14px; min-width: 90px; }' +
      '.box .l { font-size: 10px; color: #555; }' +
      '.box .v { font-size: 17px; font-weight: 800; }' +
      'table { width: 100%; border-collapse: collapse; }' +
      'thead { display: table-header-group; }' +
      'tr { page-break-inside: avoid; }' +
      'th { background: #eee; border: 1px solid #999; padding: 6px 5px; font-size: 10.5px; text-align: right; }' +
      'td { border: 1px solid #bbb; padding: 6px 5px; vertical-align: top; }' +
      '.c { text-align: center; }' +
      '.b { font-weight: 700; }' +
      'tbody tr:nth-child(even) td { background: #fafafa; }' +
      '.foot { margin-top: 18px; display: flex; justify-content: space-between; font-size: 11px; }' +
      '.sig { border-top: 1px solid #111; padding-top: 4px; width: 170px; text-align: center; }' +
      '.note { margin-top: 10px; font-size: 10.5px; color: #444; }' +
      '@media print { .noprint { display: none !important; } }' +
      '.noprint { margin-bottom: 14px; text-align: left; }' +
      '.noprint button { padding: 9px 20px; font-size: 14px; font-weight: 700; cursor: pointer; border: 1px solid #333; background: #fff; border-radius: 6px; }' +
      '</style></head><body>' +

      '<div class="noprint"><button onclick="window.print()">&#128424; طباعة</button></div>' +

      '<div class="head"><div>' +
      '<div class="brand">Mizeej</div>' +
      '<div class="title">كشف رواجع استبدالات</div>' +
      '</div><div class="meta">' +
      '<div><b>القائمة</b> #' + esc(L.id) + '</div>' +
      '<div><b>فُتحت</b> ' + (L.createdAt ? moment(L.createdAt).format('DD/MM/YYYY HH:mm') : '—') + '</div>' +
      '<div><b>قُفلت</b> ' + (L.closed_at ? moment(L.closed_at).format('DD/MM/YYYY HH:mm') : 'مفتوحة') + '</div>' +
      '<div><b>أغلقها</b> ' + esc(L.closed_by || '—') + '</div>' +
      '<div><b>الطباعة</b> ' + moment().format('DD/MM/YYYY HH:mm') + '</div>' +
      '</div></div>' +

      '<div class="sum">' +
      '<div class="box"><div class="l">مجموع الأجهزة</div><div class="v">' + items.length + '</div></div>' +
      '<div class="box"><div class="l">صيانة</div><div class="v">' + esc(data.sana_count) + '</div></div>' +
      '<div class="box"><div class="l">سوفت</div><div class="v">' + esc(data.soft_count) + '</div></div>' +
      '</div>' +

      '<table><thead><tr>' +
      '<th style="width:26px">#</th>' +
      '<th style="width:52px">الجهاز</th>' +
      '<th style="width:105px">السيريال</th>' +
      '<th style="width:150px">الاسم قبل</th>' +
      '<th style="width:52px">القسم</th>' +
      '<th style="width:135px">الأعطال</th>' +
      '<th style="width:160px">الاسم بعد</th>' +
      '<th>سبب الرجوع</th>' +
      '<th style="width:62px">الطلب</th>' +
      '</tr></thead><tbody>' +
      (rows || '<tr><td colspan="9" class="c">لا أجهزة</td></tr>') +
      '</tbody></table>' +

      (L.notes ? '<div class="note"><b>ملاحظات القائمة:</b> ' + esc(L.notes) + '</div>' : '') +

      '<div class="foot">' +
      '<div class="sig">توقيع المُسلِّم</div>' +
      '<div class="sig">توقيع المُستلِم</div>' +
      '<div class="sig">توقيع المسؤول</div>' +
      '</div></body></html>';

    const w = window.open('', '_blank', 'width=1150,height=780');
    if (!w) {
      toast.error('المتصفح منع النافذة — اسمح بالنوافذ المنبثقة لهذا الموقع',
        { position: "bottom-center", autoClose: 6000 });
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
    w.focus();
  };

  printById = (id) => {
    this.fetchList(id)
      .then(d => this.printSheet(d))
      .catch(e => toast.error(this.errMsg(e), { position: "bottom-center", autoClose: 4000 }));
  };

  // ===== جدول الأجهزة — يخدم التبويبين =====
  renderItemsTable(data, editable) {
    const items = (data && data.items) || [];
    if (!items.length) {
      return <div style={S.empty}>
        {editable ? 'لا أجهزة في القائمة — امسح باركود جهاز للبدء' : 'لا أجهزة في هذه القائمة'}
      </div>;
    }
    return (
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr>
            <th style={S.th}>الجهاز</th>
            <th style={S.th}>الاسم قبل</th>
            <th style={S.th}>القسم</th>
            <th style={S.th}>الأعطال</th>
            <th style={S.th}>{editable ? 'الاسم بعد القفل' : 'الاسم الحالي'}</th>
            <th style={S.th}>السبب</th>
            <th style={S.th}>الوقت</th>
            {editable && <th style={S.th}></th>}
          </tr></thead>
          <tbody>
            {items.map(it => (
              <tr key={it.item_id} style={it.section === 'sana' ? S.rowSana : S.rowSoft}>
                <td style={S.td}>
                  <div style={{ fontWeight: 800, fontSize: 15 }}>#{it.device_id}</div>
                  <div style={{ fontSize: 11.5, color: "#94a3b8" }}>{it.sn}</div>
                  {it.prev_order_id &&
                    <div style={{ fontSize: 11.5, color: "#94a3b8" }}>طلب #{it.prev_order_id}</div>}
                </td>
                <td style={{ ...S.td, color: "#64748b", fontSize: 12.5 }}>{it.prev_composite || '—'}</td>
                <td style={S.td}>
                  {it.section === 'sana'
                    ? <span style={S.badge("#ffedd5", "#c2410c")}>🔧 صيانة</span>
                    : <span style={S.badge("#ede9fe", "#6d28d9")}>💻 سوفت</span>}
                </td>
                <td style={S.td}>
                  {(it.fault_labels || []).map((l, i) => <span key={i} style={S.chip}>{l}</span>)}
                </td>
                <td style={{ ...S.td, fontWeight: 700 }}>
                  {(editable ? it.preview_name : (it.current_composite || it.preview_name)) || '—'}
                </td>
                <td style={{ ...S.td, fontSize: 12.5, color: "#475569", maxWidth: 210 }}>{it.notes}</td>
                <td style={{ ...S.td, fontSize: 12, color: "#94a3b8", whiteSpace: "nowrap" }}>
                  {moment(it.scanned_at).format('HH:mm')}
                  <div>{it.scanned_by_name}</div>
                </td>
                {editable && (
                  <td style={S.td}>
                    <button style={{ ...S.btnDanger, ...(this.state.busy ? S.btnDis : {}) }}
                      disabled={this.state.busy} onClick={() => this.removeItem(it)}>حذف</button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  // ===== تبويب ١: القائمة المفتوحة =====
  renderOpenTab() {
    const { open, loadingOpen, busy } = this.state;
    if (loadingOpen && !open) return <div style={S.card}><div style={S.empty}>جاري التحميل…</div></div>;
    if (!open) return <div style={S.card}><div style={S.empty}>تعذّر تحميل القائمة</div></div>;

    // المفتوحة لا تكون مقفولة عادةً. لو ظهرت كذلك فقد قُفلت في تبويب/جهاز
    // آخر — نعرض حالة انتقالية بدل تعطيل الأزرار بلا تفسير.
    const closed = !!open.list.is_closed;

    return (
      <React.Fragment>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
          <div style={S.stat}><div style={S.statLabel}>القائمة</div>
            <div style={S.statValue}>#{open.list.id}</div></div>
          <div style={S.stat}><div style={S.statLabel}>الأجهزة</div>
            <div style={S.statValue}>{open.total}</div></div>
          <div style={S.stat}><div style={S.statLabel}>🔧 صيانة</div>
            <div style={{ ...S.statValue, color: "#ea580c" }}>{open.sana_count}</div></div>
          <div style={S.stat}><div style={S.statLabel}>💻 سوفت</div>
            <div style={{ ...S.statValue, color: "#7c3aed" }}>{open.soft_count}</div></div>
        </div>

        {closed ? (
          <div style={S.card}><div style={S.pad}>
            <div style={S.okBox}>✓ قُفلت هذه القائمة — حدّث لبدء قائمة جديدة</div>
            <div style={{ display: "flex", gap: 10 }}>
              <button style={S.btnPrimary} onClick={this.loadOpen}>تحديث</button>
              <button style={S.btnPrint} onClick={() => this.printSheet(open)}>🖨 طباعة كشف</button>
            </div>
          </div></div>
        ) : (
          <div style={S.card}><div style={S.pad}>
            <div style={{ fontSize: 15, fontWeight: 800, color: "#0f172a", marginBottom: 10 }}>مسح جهاز</div>
            <div style={{ display: "flex", gap: 10 }}>
              <input ref={this.scanRef} style={S.scanInput} autoFocus
                placeholder="📷 امسح باركود الجهاز (رقم الجهاز)..."
                onKeyPress={(e) => { if (e.key === "Enter" && e.target.value) this.onScan(e.target.value); }} />
              <button style={{ ...S.btnPrimary, ...(busy ? S.btnDis : {}) }} disabled={busy}
                onClick={() => { const el = this.scanRef.current; if (el && el.value) this.onScan(el.value); }}>
                بحث
              </button>
            </div>
            <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 8 }}>
              الباركود هو <code>purchase_device.id</code> — ويُقبل السيريال أيضاً.
            </div>
          </div></div>
        )}

        <div style={S.card}>
          <div style={{
            ...S.pad, paddingBottom: 8, display: "flex", justifyContent: "space-between",
            alignItems: "center", flexWrap: "wrap", gap: 10,
          }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
              أجهزة القائمة ({open.total})
            </div>
            {!closed && open.total > 0 && (
              <button style={{ ...S.btnOk, ...(busy ? S.btnDis : {}) }} disabled={busy}
                onClick={() => this.setState({ confirmClose: true })}>
                ✓ قفل القائمة وتحويل الأجهزة
              </button>
            )}
          </div>
          {this.renderItemsTable(open, !closed)}
        </div>
      </React.Fragment>
    );
  }

  // ===== تبويب ٢: القوائم السابقة — معزول تماماً =====
  renderHistoryTab() {
    const { lists, archive, loadingArchive, kind } = this.state;
    const closedLists = lists.filter(
      l => l.is_closed && (l.kind || 'exchange') === kind);

    // عرض قائمة مقفولة واحدة — للقراءة فقط، بلا أي زر تعديل
    if (archive) {
      const L = archive.list;
      return (
        <React.Fragment>
          <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
            <button style={S.btnGhost} onClick={() => this.setState({ archive: null })}>
              ← رجوع للقوائم
            </button>
            <button style={S.btnPrint} onClick={() => this.printSheet(archive)}>🖨 طباعة كشف</button>
          </div>

          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
            <div style={S.stat}><div style={S.statLabel}>القائمة</div>
              <div style={S.statValue}>#{L.id}</div></div>
            <div style={S.stat}><div style={S.statLabel}>الأجهزة</div>
              <div style={S.statValue}>{archive.total}</div></div>
            <div style={S.stat}><div style={S.statLabel}>🔧 صيانة</div>
              <div style={{ ...S.statValue, color: "#ea580c" }}>{archive.sana_count}</div></div>
            <div style={S.stat}><div style={S.statLabel}>💻 سوفت</div>
              <div style={{ ...S.statValue, color: "#7c3aed" }}>{archive.soft_count}</div></div>
            <div style={S.stat}><div style={S.statLabel}>قُفلت</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", marginTop: 4 }}>
                {L.closed_at ? moment(L.closed_at).format('DD/MM/YYYY HH:mm') : '—'}
                <div style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>{L.closed_by}</div>
              </div></div>
          </div>

          <div style={S.card}>
            <div style={{ ...S.pad, paddingBottom: 8, fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
              أجهزة القائمة #{L.id}
              <span style={{ fontSize: 12.5, fontWeight: 600, color: "#94a3b8", marginInlineStart: 10 }}>
                للقراءة فقط — القائمة مقفولة
              </span>
            </div>
            {loadingArchive ? <div style={S.empty}>جاري التحميل…</div>
              : this.renderItemsTable(archive, false)}
          </div>
        </React.Fragment>
      );
    }

    // سرد القوائم المقفولة
    return (
      <div style={S.card}>
        <div style={{ ...S.pad, paddingBottom: 8, fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
          القوائم المقفولة ({closedLists.length})
        </div>
        {this.state.listsError ? (
          <div style={{ ...S.pad, paddingTop: 0 }}>
            <div style={S.warnBox}>
              ⚠ تعذّر تحميل القوائم — {this.state.listsError}
              <div style={{ fontWeight: 500, marginTop: 6, fontSize: 12.5 }}>
                إن كانت الرسالة عن عمود غير معروف (kind أو prev_status) فملف
                <b> alter_exchange_kind.sql </b> لم يُشغَّل بعد.
              </div>
            </div>
            <button style={S.btnPrimary} onClick={this.loadLists}>إعادة المحاولة</button>
          </div>
        ) : closedLists.length === 0 ? (
          <div style={S.empty}>
            لا قوائم مقفولة في «{kind === 'stock' ? 'تحويل من المخزن' : 'رواجع استبدالات'}» بعد
            <div style={{ fontSize: 12.5, marginTop: 8, color: "#94a3b8" }}>
              مجموع القوائم المحمّلة: {lists.length} · المقفولة من هذا النوع: {closedLists.length}
            </div>
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr>
                <th style={S.th}>القائمة</th>
                <th style={S.th}>فُتحت</th>
                <th style={S.th}>قُفلت</th>
                <th style={S.th}>أغلقها</th>
                <th style={S.th}>الأجهزة</th>
                <th style={S.th}>🔧 صيانة</th>
                <th style={S.th}>💻 سوفت</th>
                <th style={S.th}></th>
              </tr></thead>
              <tbody>
                {closedLists.map(l => (
                  <tr key={l.id}>
                    <td style={{ ...S.td, fontWeight: 800, fontSize: 15 }}>#{l.id}</td>
                    <td style={{ ...S.td, fontSize: 12.5, color: "#64748b" }}>
                      {moment(l.createdAt).format('DD/MM/YYYY')}
                    </td>
                    <td style={{ ...S.td, fontSize: 12.5 }}>
                      {l.closed_at ? moment(l.closed_at).format('DD/MM/YYYY HH:mm') : '—'}
                    </td>
                    <td style={{ ...S.td, fontSize: 12.5 }}>{l.closed_by || '—'}</td>
                    <td style={{ ...S.td, fontWeight: 700 }}>{l.items_count}</td>
                    <td style={{ ...S.td, color: "#ea580c", fontWeight: 700 }}>{l.sana_count}</td>
                    <td style={{ ...S.td, color: "#7c3aed", fontWeight: 700 }}>{l.soft_count}</td>
                    <td style={S.td}>
                      <div style={{ display: "flex", gap: 7 }}>
                        <button style={S.btnGhost} onClick={() => this.openArchive(l.id)}>عرض</button>
                        <button style={S.btnPrint} onClick={() => this.printById(l.id)}>🖨 كشف</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }

  renderModal() {
    const { modal, section, faults, notes, busy } = this.state;
    if (!modal) return null;
    const d = modal.device || {};
    return (
      <div style={S.overlay} onClick={() => this.setState({ modal: null }, () => this.focusScan())}>
        <div style={S.modal} onClick={(e) => e.stopPropagation()}>
          <div style={S.modalHead}>
            <div>
              <div style={{ fontSize: 19, fontWeight: 800, color: "#0f172a" }}>جهاز #{d.device_id}</div>
              <div style={{ fontSize: 13, color: "#64748b", marginTop: 3 }}>{d.composite_name}</div>
            </div>
            <button style={S.btnGhost}
              onClick={() => this.setState({ modal: null }, () => this.focusScan())}>إلغاء</button>
          </div>
          <div style={{ padding: 22 }}>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
              {[
                ['السيريال', d.sn || '—'],
                ['الذاكرة', d.storage || '—'],
                ['البطارية', d.battery ? d.battery + '%' : '—'],
                [modal.kind === 'stock' ? 'الحالة' : 'طلب البيع',
                  modal.kind === 'stock'
                    ? 'في المخزن'
                    : (modal.order_id ? '#' + modal.order_id : '—')],
                ['رجع سابقاً', d.return_count ? d.return_count + ' مرة' : 'لا'],
              ].map(([l, v], i) => (
                <div key={i} style={{ ...S.stat, minWidth: 110, padding: "11px 13px" }}>
                  <div style={S.statLabel}>{l}</div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: "#0f172a" }}>{v}</div>
                </div>
              ))}
            </div>

            {/* الطلب لا وجود له في «تحويل من المخزن» — الجهاز لم يُبَع */}
            {modal.kind === 'stock' ? (
              <div style={S.okBox}>📦 جهاز مخزون — لا طلب بيع مرتبط به</div>
            ) : modal.is_replacement_order ? (
              <div style={S.okBox}>
                ✓ الطلب مُعلَّم استبدالاً
                {modal.order_id ? <b> — طلب #{modal.order_id}</b> : null}
              </div>
            ) : (
              <div style={S.warnBox}>
                ⚠ طلب البيع غير مُعلَّم استبدالاً
                {modal.order_id ? <b> (طلب #{modal.order_id})</b> : ' — لم يُعرف الطلب'}
                {" "}— تأكّد أنك تمسح الجهاز الصحيح
              </div>
            )}

            <div style={{ fontSize: 14, fontWeight: 800, color: "#0f172a", marginBottom: 9 }}>
              القسم <span style={{ color: "#dc2626" }}>*</span>
            </div>
            <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
              <div style={S.secBtn(section === 'sana', '#ea580c')}
                onClick={() => this.setState({ section: 'sana' })}>🔧 صيانة</div>
              <div style={S.secBtn(section === 'soft', '#7c3aed')}
                onClick={() => this.setState({ section: 'soft' })}>💻 سوفت</div>
            </div>

            <div style={{ fontSize: 14, fontWeight: 800, color: "#0f172a", marginBottom: 9 }}>
              الأعطال
              {this.faultRequired()
                ? <span style={{ color: "#dc2626" }}> *</span>
                : null}
              <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b", marginInlineStart: 8 }}>
                {section === 'soft'
                  ? 'اختياري — السوفت مشكلته برمجية، السبب المكتوب يكفي'
                  : section === 'sana' ? 'واحد على الأقل'
                    : 'إلزامي للصيانة، اختياري للسوفت'}
              </span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8, marginBottom: 14 }}>
              {FAULTS.map(f => (
                <div key={f.k} style={S.faultBtn(faults[f.k])} onClick={() => this.toggleFault(f.k)}>
                  {f.l}
                </div>
              ))}
            </div>

            <label style={{
              display: "flex", alignItems: "center", gap: 9, marginBottom: 18,
              padding: "11px 14px", background: "#f8fafc", borderRadius: 10,
              border: "1px solid #eef2f7", cursor: "pointer",
            }}>
              <input type="checkbox" checked={faults.no_touch_id}
                onChange={() => this.toggleFault('no_touch_id')}
                style={{ width: 17, height: 17, cursor: "pointer" }} />
              <span style={{ fontSize: 13.5, fontWeight: 700, color: "#334155" }}>بدون بصمة نهائياً</span>
              <span style={{ fontSize: 12, color: "#64748b" }}>— وسم دائم يدخل الاسم المركّب، لا عطل</span>
            </label>

            <div style={{ fontSize: 14, fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>
              سبب الرجوع <span style={{ color: "#dc2626" }}>*</span>
            </div>
            <textarea rows={3} value={notes}
              onChange={(e) => this.setState({ notes: e.target.value })}
              placeholder="مثال: الزبون استبدله — الشاشة فيها خطوط"
              style={{ ...S.input, width: "100%", resize: "vertical", marginBottom: 18 }} />

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button style={S.btnGhost}
                onClick={() => this.setState({ modal: null }, () => this.focusScan())}>إلغاء</button>
              <button style={{ ...S.btnPrimary, ...(this.canAdd() && !busy ? {} : S.btnDis) }}
                disabled={!this.canAdd() || busy} onClick={this.confirmAdd}>إضافة للقائمة</button>
            </div>
            {!this.canAdd() && (
              <div style={{ fontSize: 12, color: "#94a3b8", textAlign: "left", marginTop: 8 }}>
                {!section ? 'اختر القسم'
                  : (this.faultRequired() && !this.anyFault())
                    ? 'الصيانة تحتاج عطلاً واحداً على الأقل'
                    : 'اكتب سبب الرجوع'}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderConfirmClose() {
    if (!this.state.confirmClose) return null;
    const { open, busy } = this.state;
    return (
      <div style={S.overlay} onClick={() => this.setState({ confirmClose: false })}>
        <div style={{ ...S.modal, maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
          <div style={S.modalHead}>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#0f172a" }}>قفل القائمة</div>
          </div>
          <div style={{ padding: 22 }}>
            <div style={S.warnBox}>
              ⚠ عند القفل تتغيّر الأجهزة فعلياً: تنتقل لقسمها، يُبنى اسمها المركّب
              من جديد، ويُفكّ ربطها بطلب البيع. لا تراجع بعد القفل.
            </div>
            <div style={{ fontSize: 15, color: "#0f172a", marginBottom: 6 }}>
              سيُحوَّل <b>{open.total}</b> جهاز:
            </div>
            <div style={{ fontSize: 14, color: "#475569", marginBottom: 20 }}>
              🔧 صيانة: <b>{open.sana_count}</b> &nbsp;·&nbsp; 💻 سوفت: <b>{open.soft_count}</b>
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button style={S.btnGhost} onClick={() => this.setState({ confirmClose: false })}>إلغاء</button>
              <button style={{ ...S.btnOk, ...(busy ? S.btnDis : {}) }}
                disabled={busy} onClick={this.doClose}>تأكيد القفل</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { tab, open, lists, kind } = this.state;
    if (!cookies.get("token")) return <div style={S.page}>يجب تسجيل الدخول</div>;

    // القوائم السابقة تُفلتر بالنوع المختار — العزل كامل
    const ofKind = lists.filter(l => (l.kind || 'exchange') === kind);
    const closedCount = ofKind.filter(l => l.is_closed).length;
    const openCount = open ? open.total : 0;

    return (
      <div style={S.page}>
        <div style={S.inner}>
          <h1 style={S.h1}>
            {kind === 'stock' ? '📦 تحويل من المخزن' : '🔁 رواجع استبدالات'}
          </h1>
          <p style={S.sub}>
            {kind === 'stock'
              ? 'جهاز في المخزن لم يُبَع ويحتاج صيانة أو سوفت — يُمسح هنا برقمه، يُحدَّد عطله وقسمه، ويُناقَل عدّه من صنفه الحالي لصنف قسمه عند القفل.'
              : 'الجهاز الراجع من زبون بسبب استبدال لا يدخل المخزن — يُمسح هنا برقمه، يُحدَّد عطله وقسمه، ولا يتغيّر شيء حتى قفل القائمة.'}
          </p>

          {/* نوع القائمة — قائمة مفتوحة واحدة لكل نوع */}
          <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
            {[
              { k: 'exchange', icon: '🔁', l: 'رواجع استبدالات', h: 'جهاز رجع من زبون (مباع)' },
              { k: 'stock', icon: '📦', l: 'تحويل من المخزن', h: 'جهاز في المخزن لم يُبَع' },
            ].map(o => (
              <div key={o.k} title={o.h}
                style={{
                  padding: "13px 20px", borderRadius: 12, cursor: "pointer",
                  fontSize: 14.5, fontWeight: 800,
                  border: kind === o.k ? "2px solid #0f172a" : "1px solid #e2e8f0",
                  background: kind === o.k ? "#0f172a" : "#fff",
                  color: kind === o.k ? "#fff" : "#475569",
                }}
                onClick={() => {
                  if (kind === o.k) return;
                  this.setState({ kind: o.k, tab: 'open', archive: null, modal: null },
                    () => { this.loadOpen(); this.loadLists(); });
                }}>
                {o.icon} {o.l}
                <div style={{
                  fontSize: 11.5, fontWeight: 600, marginTop: 2,
                  color: kind === o.k ? "rgba(255,255,255,.7)" : "#94a3b8",
                }}>{o.h}</div>
              </div>
            ))}
          </div>

          <div style={S.tabs}>
            <div style={S.tab(tab === 'open')}
              onClick={() => this.setState({ tab: 'open' }, () => this.focusScan())}>
              📥 القائمة المفتوحة
              <span style={S.tabCount(tab === 'open')}>{openCount}</span>
            </div>
            <div style={S.tab(tab === 'history')}
              onClick={() => this.setState({ tab: 'history', archive: null }, () => this.loadLists())}>
              🗂 القوائم السابقة
              <span style={S.tabCount(tab === 'history')}>{closedCount}</span>
            </div>
          </div>

          {tab === 'open' ? this.renderOpenTab() : this.renderHistoryTab()}
        </div>

        {this.renderModal()}
        {this.renderConfirmClose()}
        <ToastContainer position="bottom-center" autoClose={3000} rtl closeOnClick pauseOnHover newestOnTop />
      </div>
    );
  }
}